import React from 'react';

type ScriptInlineProps = {
    script: string;
    testId?: string;
};

export const ScriptInline: React.FC<ScriptInlineProps> = ({
    script,
    testId = 'inline-script'
}) => (
    <script
        data-testid={testId}
        dangerouslySetInnerHTML={{
            __html: script
        }}
    ></script>
);
